import { analyticsClient } from "./analyticsClient/analyticsClient";
import { analyticsClientStub } from "./analyticsClient/stub";
import { competitionsClientStub } from "./competitionsClient/stub";
export var legacyClients = {
    analyticsClient: analyticsClient,
    // TODO(mbooth): Migrate to Command Handler. Currently using adhocClient.
    competitionsClient: {}
};
export var legacyClientsStub = {
    analyticsClient: analyticsClientStub,
    competitionsClient: competitionsClientStub
};
